import { render } from "./CertificateIcon.vue?vue&type=template&id=d4473f84"
import script from "./CertificateIcon.vue?vue&type=script&lang=js"
export * from "./CertificateIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__